function main() {
  if (window.location.hash === "#aoskdopoidsa") {
    document.querySelector("framebase.private-0").classList.remove("private-0");
  }
}

document.addEventListener("DOMContentLoaded", main);
